import { z } from 'zod';

export const GetCuratorShopLinkServiceRequestDtoSchema = z.object({
  snsTitle: z.string().min(1),
});

export type GetCuratorShopLinkServiceRequest = z.infer<
  typeof GetCuratorShopLinkServiceRequestDtoSchema
>;

export const GetCuratorShopLinkServiceResponseDtoSchema = z.object({
  platform: z.enum(['MUSINSA', '29CM']),
  /** 큐레이터샵 origin URL (UTM 파라미터 포함) */
  originUrl: z.string(),
  /** 큐레이터샵 단축 URL */
  shortUrl: z.string(),
});

export type GetCuratorShopLinkServiceResponse = z.infer<
  typeof GetCuratorShopLinkServiceResponseDtoSchema
>;
